<template>
  <keep-alive>
    <div class="withdrawBenefit">
      <!-- <span class="applydrawable">申請提領</span> -->
      <!-- <div class="divider"></div> -->
      <div class="WithdrawableAmount">
        <span>{{$t('upgrade_page_views_withdraw_index_1557')}}</span>
        <span class="amountD">$</span>
        <span v-if="accountInfo" class="amountD1">{{
          accountInfo.reward
        }}</span>
        <span>{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1583', [ limit ])}}</span>
      </div>
      <el-form :model="applyForm" :rules="rules" ref="applyForm">
        <el-form-item :label="$t('upgrade_page_views_withdraw_index_1558')" prop="amount" class="amount">
          <el-input v-model="applyForm.amount" autocomplete="off"></el-input>
          <div class="AmountDes">
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1584')}}</p>
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1585')}}</p>
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1586')}}</p>
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1587')}}</p>
          </div>
        </el-form-item>
      </el-form>
      <section class="withdraw-account-info">
        <h3 class="info-title">
          <span>{{$t('upgrade_page_views_withdraw_index_1564')}}</span>
          <span class="go-edit-info" @click="gotoEditBank"
            >{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1609')}}</span
          >
        </h3>
        <div class="info-body">
          <div class="info-box">
            <div
              class="info-line"
              v-for="(item, index) in withdrawBlankInfo"
              :key="index + 'a'"
            >
              <span class="info-label">{{ item.label }}</span>
              <span>{{ item.value }}</span>
            </div>
          </div>
          <p class="info-tips">{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1588')}}</p>
        </div>
      </section>
      <div class="reads">
        <div class="reads_s" @click="changeIsKeepStatus">
          <div class="circle-wrap" :class="isKeepStatus && 'selected'">
            <fps-icon v-if="isKeepStatus" type="check" size="12" />
          </div>
          <div>{{$t('upgrade_page_views_settled_in_before_settled_1136')}}<span style="color: #0091FF;" @click.stop="open()">{{$t('upgrade_page_views_withdraw_index_1572')}}</span>
          </div>
        </div>
        <span class="isRead" :class="{ activeKeep: !isReads }"
          >{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1589')}}</span
        >
      </div>
      <div class="footer">
        <NButton
          class="apply-button"
          :loading="isLoading"
          :disabled="disabledSubmit"
          @click="submitForm('applyForm')"
        >
          <template v-if="reviewStatus === 'Applying'">{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1590')}}</template>
          <template v-else>{{$t('components_order_order_card_525')}}</template>
        </NButton>
      </div>
      <el-dialog
        :title="$t('upgrade_page_views_withdraw_index_1572')"
        :visible.sync="dialogVisible"
        width="418px"
        :append-to-body="true"
        class="dislogmethods"
      >
        <div class="divider_mthods"></div>
        <div>{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1591')}}</div>
        <div>{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1592')}}</div>
        <div>{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1593')}}</div>
        <div>{{$t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1594')}}</div>
      </el-dialog>
    </div>
  </keep-alive>
</template>

<script>
import i18n from '@/locales/index'
import { withdrawApplyV2, getBankInfo } from '@/api';
import { mapGetters } from 'vuex';
import NButton from '@/components/common/button/normal.vue';
export default {
  name: 'WithdrawBenefit',
  components: {
    NButton
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      isKeepStatus: false,
      dialogFormVisible: false,
      currencyKind: '',
      isReads: false,
      visible: false,
      // withdrawBlankInfo: [
      //   { value: '***', label: '用戶名稱' },
      //   { value: '***', label: '提領銀行名' },
      //   { value: '***', label: '分行代碼' },
      //   { value: '***', label: '提領帳戶' }
      // ],
      applyForm: {
        amount: ''
      },
      reviewStatus: '',
      isWechat: false,
      isAlipay: false,
      limit: 0,
      bankInfo: null
    };
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['accountInfo']),
    rules() {
      const { isAccount } = this;
      let rs = {
        amount: [
          { required: true, message: i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1595'), trigger: 'blur' },
          { validator: isAccount, trigger: 'blur' }
        ]
      };
      return rs;
    },
    disabledSubmit() {
      return this.reviewStatus !== 'Passed';
    },
    withdrawBlankInfo() {
      return [
        { value: '***', label: i18n.t('upgrade_page_views_withdraw_index_1565') },
        { value: '***', label: i18n.t('upgrade_page_views_withdraw_index_1566') },
        {
          value: '***',
          label: this.isWechat
            ? i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1610')
            : this.isAlipay
            ? i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1611')
            : i18n.t('upgrade_page_views_withdraw_index_1567')
        },
        {
          value: '***',
          label: this.isWechat
            ? i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1612')
            : this.isAlipay
            ? i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1613')
            : i18n.t('upgrade_page_views_withdraw_index_1568')
        }
      ];
    }
  },
  watch: {
    isKeepStatus(flag) {
      if (flag) {
        this.isReads = false;
      } else {
        this.isReads = true;
      }
    },
    isShow: {
      handler: function(newVal) {
        if (!newVal) return;
        this.$nextTick(() => {
          this.bankInfoPromise.then(() => {
            if (!this.bankAccountId || this.reviewStatus === 'Rejected')
              this.confirmApplyBank();
          });
        });
      },
      immediate: true
    }
  },
  methods: {
    // 获取剩余提领额度
    async getLimit() {
      const { data } = await this.$http.get(
        '/account/withdraw/apply/v2/restrict',
        {
          addAmount: 0
        }
      );
      this.limit = data && Number(data) > 0 ? data : 0;
    },
    gotoEditBank() {
      if (this.reviewStatus === 'Applying') {
        this.$message.warning(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1596'));
        return;
      }
      this.$router.push({ path: '/withdraw-account' });
    },
    getBankAccount() {
      let loads = this.$loading();
      this.bankInfoPromise = getBankInfo()
        .then(res => {
          let blankInfo = this.$util.getVal(res, 'data.0');
          this.bankInfo = blankInfo
          loads.close();
          if (!blankInfo) return;
          if (blankInfo.bankName === i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1597')) {
            this.isWechat = true;
            this.withdrawBlankInfo[0].value = blankInfo.accountUserName;
            this.withdrawBlankInfo[1].value = blankInfo.bankName;
            this.withdrawBlankInfo[2].value = blankInfo.branchName;
            this.withdrawBlankInfo[3].value = blankInfo.accountNo;
          } else if (blankInfo.bankName === i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1598')) {
            this.isAlipay = true;
            this.withdrawBlankInfo[0].value = blankInfo.accountUserName;
            this.withdrawBlankInfo[1].value = blankInfo.bankName;
            this.withdrawBlankInfo[2].value = blankInfo.branchName;
            this.withdrawBlankInfo[3].value = blankInfo.accountNo;
          } else {
            this.withdrawBlankInfo[0].value =
              '**' + blankInfo.accountUserName.slice(-1);
            this.withdrawBlankInfo[1].value = blankInfo.bankName;
            this.withdrawBlankInfo[2].value = blankInfo.branchName;
            this.withdrawBlankInfo[3].value =
              '**** ' + blankInfo.accountNo.slice(-4);
          }
          this.bankAccountId = blankInfo.id;
          this.reviewStatus = blankInfo.reviewStatus;
        })
        .catch(e => {
          console.error(e);
          loads.close();
        });
    },
    confirmApplyBank() {
      let isReject = this.reviewStatus === 'Rejected';
      let rejectText = i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1599');
      let text = isReject
        ? rejectText
        : i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1600');
      return this.$confirm({
        content: text,
        confirmButtonText: i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1601'),
        cancelButtonText: i18n.t('upgrade_page_layout_header_45')
      })
        .then(() => {
          this.gotoEditBank();
        })
        .catch(() => {
          return false;
        });
    },
    isAccount(rule, value, callback) {
      const { accountInfo } = this;
      if (!accountInfo) return;
      let isNormal = this.$route.query.isNormal;
      //輸入的數字可以是整數，可以是小數，但是不能超過2位小數
      let regEn = /^\d{1,4}$/;
      if (isNormal === 'Invitation') {
        if (value >= 10000) {
          callback(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1602'));
        } else if (!regEn.test(value)) {
          callback(new Error(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1603')));
        } else if (value > accountInfo.reward) {
          callback(new Error(i18n.t('upgrade_page_views_quick_order_index_1228')));
        } else if (value == 0) {
          callback(new Error(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1604')));
        }
      } else {
        if (value > this.limit) {
          callback(new Error(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1605')));
        }
        if (value >= 10000) {
          callback(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1602'));
        } else if (!regEn.test(value)) {
          callback(new Error(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1603')));
        } else if (value < 1000) {
          callback(new Error(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1606')));
        } else if (value > accountInfo.reward) {
          callback(new Error(i18n.t('upgrade_page_views_quick_order_index_1228')));
        } else if (value == 0) {
          callback(new Error(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1604')));
        }
      }

      callback();
    },
    /**
     * @description 是否记住選擇状态
     */
    changeIsKeepStatus() {
      this.isKeepStatus = !this.isKeepStatus;
    },
    submitForm(formName) {
      if (this.bankInfo.bankName == i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1597')) {
        this.$confirm({
          content: i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1607'),
          title: i18n.t('upgrade_page_views_order_confirm_order_291'),
          showCancelButton: false,
          confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
          closeOnClickModal: false
        });
        return;
      }
      if (this.isLoading) return;
      if (this.reviewStatus === 'Applying') {
        this.$message(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1608'));
        return;
      }
      if (this.disabledSubmit) {
        this.confirmApplyBank();
        return;
      }
      this.$refs[formName].validate(async valid => {
        if (!valid) return;
        let params = {
          accountKind: 'Reward', //個人帳戶reward   激勵帳戶Cash 要根據不同情況實時改變字段
          bankAccountId: this.bankAccountId, //綁定的銀行帳戶
          currencyKind: 'TWD', //貨幣類型
          withdrawKind: 'Normal',
          amount: this.applyForm.amount
        };

        if (this.isKeepStatus) {
          //ajax
          this.isLoading = true;
          withdrawApplyV2(params)
            .then(res => {
              if (res.code == 200) {
                this.$message.success(i18n.t('components_order_order_card_564'));
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg);
              }
              this.isLoading = false;
            })
            .catch(e => {
              this.isLoading = false;
              if (e.msg) {
                this.$message.error(e.msg);
              }
            });
        } else {
          this.isReads = true;
        }
      });
    },
    open() {
      this.dialogVisible = true;
    }
  },
  created() {
    this.getBankAccount();
    this.getLimit();
  }
};
</script>
<style lang="scss" scoped>
.withdrawBenefit {
  margin: 0 auto;
  padding-bottom: 60px;
  margin-bottom: 100px;
  background: #ffffff;
  .el-dialog__wrapper {
    & /deep/ .el-dialog {
      border-radius: 8px;
    }
    & /deep/ .el-dialog__body {
      padding: 0;
      padding-bottom: 60px;
      // padding: 0 30px 60px 30px;
      .divider_mthods {
        width: 100%;
        height: 1px;
        background: #ececec;
      }
      div {
        font-size: 14px;
        color: #333333;
        padding: 0 30px 0 30px;
        line-height: 20px;
        margin-bottom: 20px;
      }
    }
  }
  .footer {
    width: 142px;
    height: 46px;
    border-radius: 4px;
    text-align: center;
    margin-left: 40px;
    button {
      width: 168px;
      height: 48px;
      border-radius: 50px;
      background: $color-yellow;
      font-weight: 500;
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      letter-spacing: -0.000319808px;
      color: $color-gray-1;
    }
  }
  .reads {
    width: 191px;
    margin-left: 40px;
    text-align: center;
    overflow: hidden;
    .reads_s {
      cursor: pointer;
      display: flex;
      div {
        vertical-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        span {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .circle-wrap {
      width: 16px;
      height: 16px;
      border: 1px solid #8c94aa;
      box-sizing: border-box;
      box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      margin-right: 8px;
      cursor: pointer;
      &.selected {
        border: none;
        background: $color-yellow;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .isRead {
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      color: #fd2243;
    }
    .activeKeep {
      opacity: 0;
    }
  }
  & /deep/ .el-form {
    padding: 0 40px;
    overflow: hidden;
    .amount {
      position: relative;
      height: 90px;
      & /deep/ .el-form-item__content {
        line-height: 20px;
      }
      .AmountDes {
        position: absolute;
        left: 454px;
        top: 25px;
        font-weight: normal;
        font-size: 13px;
        color: #636d86;
        line-height: 17px;
      }
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      padding-bottom: 5px;
      &::before {
        content: '';
      }
    }
    .el-form-item__content {
      .el-form-item__error {
        font-weight: 500;
        font-size: 12px;
        color: #fd2243;
      }
      .el-input {
        .el-input__inner {
          width: 434px;
          background: #f6f6f6;
          border-radius: 4px;
          &::placeholder {
            font-size: 14px;
          }
          &:focus {
            background: #ffffff;
            box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
          }
        }
      }
      el-select {
        width: 434px;
        height: 40px;
        background: #f6f6f6;
        border-radius: 4px;
      }
    }
  }
  el-select {
    width: 434px;
    height: 40px;
    background: #f6f6f6;
    border-radius: 4px;
  }

  .applydrawable {
    margin-left: 40px;
    font-size: 22px;
    line-height: 31px;
    color: #333333;
  }
  .divider {
    width: 1200px;
    height: 2px;
    background: #f4f4f4;
    margin-top: 20px;
  }
  .WithdrawableAmount {
    margin-left: 40px;
    margin-top: 32px;
    margin-bottom: 42px;
    display: flex;
    align-items: center;
    span {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: $color-gray-1;
      margin-right: 12px;
    }
    .amountD,
    .amountD1 {
      font-weight: 600;
      font-size: 22px;
      line-height: 26px;
      color: $color-orange;
    }
  }
}
.withdraw-account-info {
  padding: 0 40px;
}
.info-title {
  display: flex;
  justify-content: space-between;
  width: 434px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #222c43;
}
.go-edit-info {
  font-weight: 400;
  font-size: 12px;
  color: #007aff;
  cursor: pointer;
}
.info-body {
  display: flex;
  justify-content: space-between;
  margin-bottom: 56px;
}
.info-box {
  flex-grow: 0;
  flex-shrink: 0;
  width: 434px;
  padding: 10px 12px;
  border: 1px solid #e8eaee;
  margin-right: 20px;
  font-size: 13px;
  line-height: 18px;
  color: #636d86;
  border-radius: 4px;
  background: #f9f9f9;
}
.info-line {
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
}
.info-label {
  display: inline-block;
  width: 100px;
}
.info-tips {
  font-size: 13px;
  line-height: 18px;
  color: #636d86;
}
.apply-button {
  min-width: 156px;
}
</style>
